module.exports = __webpack_public_path__ + "img/special_liftserum.b9225e21.jpg";